// Copyright 2017-2023 @polkadot/api-contract authors & contributors
// SPDX-License-Identifier: Apache-2.0

export function v3ToV4(registry, v3) {
  return v3;
}